import { render, staticRenderFns } from "./ApiButton.vue?vue&type=template&id=5f220a02&"
import script from "./ApiButton.vue?vue&type=script&lang=js&"
export * from "./ApiButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f220a02')) {
      api.createRecord('5f220a02', component.options)
    } else {
      api.reload('5f220a02', component.options)
    }
    module.hot.accept("./ApiButton.vue?vue&type=template&id=5f220a02&", function () {
      api.rerender('5f220a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-api/components/ApiButton.vue"
export default component.exports